import CartCoupon from '../../../../../ui/svg/shopping-cart/coupon';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import React from 'react';
import { useAppSelector } from '../../data/store';
import { getUpsellBoxStatus } from '../../../../../domain/upsell/upsell-provider';
import { UpsellReferrer } from '../../../../../domain/upsell/interfaces';

const InstantSavings = () => {
    const cartData = useAppSelector(store => store.root.cartData);

    const result = getUpsellBoxStatus(
        cartData,
        UpsellReferrer.CartStep1 // doesn't matter
    );

    if(result.isVisible) return null;

    return (
        <>
            {
               cartData.priceData.totalUpsellDiscount > 0 &&
                <div className="text-gray-700 border border-green rounded bg-green-100 px-3 py-2 flex items-center mb-4" role="alert">
                    <div className="text-green"><CartCoupon width="27" /></div>
                    <div className="flex flex-col mx-4 flex-1">Instant Savings</div>
                    <div className="text-green">
                        -<ProductPriceFormat price={ cartData.priceData.totalUpsellDiscount } />
                    </div>
                </div>
            }
        </>
    )
};

export default InstantSavings;